import type { LayoutPoint, NodeType } from '../data/types';

const typeBand: Record<NodeType, number> = {
  company: 0,
  person: 1,
  architecture: 2,
  place: 3,
  machine: 4,
  technology: 5,
  process: 6,
  textile: 7,
  document: 8,
  photograph: 9,
  map: 10,
  event: 11,
  trade: 12,
  heritage: 13,
};

function hash(value: string): number {
  let result = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    result ^= value.charCodeAt(index);
    result = Math.imul(result, 16777619);
  }
  return result >>> 0;
}

/** A repeatable base arrangement; interaction adds temporary strain to it. */
export function layoutFor(id: string, type: NodeType, ordinal: number): LayoutPoint {
  const seed = hash(id);
  const band = typeBand[type];
  const angle = ((seed % 360) * Math.PI) / 180 + ordinal * 0.17;
  const radius = 2.2 + ((seed >>> 8) % 100) / 34;
  const layer = band % 4;
  return {
    x: Math.cos(angle) * radius + (band - 6.5) * 0.27,
    y: Math.sin(angle) * radius * 0.68 + ((seed >>> 16) % 100) / 70 - 0.7,
    z: (layer - 1.5) * 0.38 + ((seed >>> 24) % 11) / 30,
    layer,
  };
}

